/*
 * @Author: whb
 * @Date: 2023-01-10 19:28:04
 * @LastEditors: whb
 * @LastEditTime: 2023-01-12 14:33:46
 * @Description: 区域&语言 选择
 */
import React, { useState, useEffect } from "react";
import i18n from "../../i18n";
import "./index.scss";
import { NORMAL_APP } from "../../libs/constant";
// import i18n from '../../i18n';
const SelectRegion = (props) => {
  const [isSelRegion, setIsSelRegion] = useState(false);
  const [selLang, setSelLang] = useState("en");
  const [childVersion, setChildVersion] = useState("");
  const list = [
    {
      id: 1,
      title: i18n.us,
      desc: i18n.usDesc,
      text: 'us'
    },
    {
      id: 2,
      title: i18n.eea,
      desc: i18n.eeaDesc,
      text: 'eea'
    },
    {
      id: 3,
      title: i18n.otherRegion,
      desc: i18n.otherRegionDesc,
      text: 'row'
    }
  ];
  const langSwitch = (val) => {
    setSelLang(val);
  };
  const doSwitch = (val) => {
    setChildVersion(val);
  };
  const emitSel = (init = false) => {
    props.sel({
      version: childVersion,
      lang: selLang,
      init
    });
  };
  const toNext = () => {
    if (isSelRegion) {
      emitSel();
      props.hide();
    } else {
      setIsSelRegion(true);
    }
  };
  useEffect(() => {
    if (props.defaultVersion) {
      setChildVersion(props.defaultVersion);
    }
  }, [props.defaultVersion]);
  useEffect(() => {
    if (props.display) {
      setIsSelRegion(false);
    }
  }, [props.display]);
  return (
    <div className="select-region">
      <div className="title-box">
        <div className="title">
          {props.langs[isSelRegion ? i18n.selectLang : i18n.selectRegion]}
        </div>
        <div className="close" onClick={props.hide}></div>
      </div>
      <div className="tips">{props.langs[i18n.selectLangTips]}</div>
      {isSelRegion ? (
        <div className="lang-box">
          {NORMAL_APP[childVersion] &&
            NORMAL_APP[childVersion].langList &&
            NORMAL_APP[childVersion].langList.map((item) => {
              return (
                <div
                  key={item.key}
                  className={[
                    "lang-item",
                    selLang === item.key ? "active" : "",
                  ].join(" ")}
                  onClick={() => langSwitch(item.key)}
                >
                  <span>{item.value}</span>
                </div>
              );
            })}
        </div>
      ) : (
        <div className="region">
          {
            list && list.map((item) => {
              return (
                <div key={item.id} className={['region-item', childVersion === item.text ? 'active' : ''].join(' ')}
                  onClick={() => doSwitch(item.text)}>
                  <div className="item-title">{props.langs[item.title]}</div>
                  <div className="item-desc">{props.langs[item.desc]}</div>
                </div>
              )
            })
          }
        </div>
      )}
      <div className="btn-box">
        <div className="cancel" onClick={isSelRegion ? () => setIsSelRegion(false) : props.hide}>{props.langs[isSelRegion ? i18n.back :
        i18n.cancel]}</div>
        <div className="next" onClick={toNext}>{props.langs[i18n.next]}</div>
      </div>
    </div>
  );
};
export default SelectRegion;
